import { OfferCardProps } from "./types";

export function generateOfferTitle(data: OfferCardProps["data"]): string {
  switch (data.type) {
    case "classAction":
      return `${data.title} Class Action`;
    case "bank":
      return `Bank signup offer from ${data.title}`;
    default:
      return data.title || "";
  }
}

export function isValidOfferType(data: OfferCardProps["data"]): boolean {
  return (
    data.type === "classAction" ||
    data.type === "bank" ||
    data.type === "unclaimedProperty" ||
    data.type === "unclaimedMoney"
  );
}
